// Политика обработки персональных данных.
// Обязательный документ по 152-ФЗ «О персональных данных» (РФ).
// Открывается со страницы входа по ссылке из согласия пользователя.

import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function Privacy() {
  const navigate = useNavigate();
  return (
    <div className="min-h-full px-6 pt-6 pb-10 max-w-2xl mx-auto">
      <button
        className="text-slate-500 text-sm flex items-center gap-1 self-start -ml-1 mb-4"
        onClick={() => navigate(-1)}
      >
        <ArrowLeft size={16} /> Назад
      </button>

      <h1 className="text-2xl font-semibold mb-2">Политика обработки персональных данных</h1>
      <p className="text-xs text-slate-500 mb-6">Редакция от {new Date().getFullYear()} года</p>

      <div className="prose prose-slate max-w-none text-[14px] leading-relaxed space-y-4">
        <p>
          Настоящая Политика в отношении обработки персональных данных (далее — «Политика») разработана
          в целях исполнения требований Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных»
          и определяет порядок обработки персональных данных и меры по обеспечению их безопасности,
          принимаемые оператором заведения общественного питания (далее — «Оператор»),
          использующим настоящий сервис заказа для своих гостей.
        </p>

        <h2 className="text-base font-semibold mt-4">1. Термины</h2>
        <p>
          <b>Персональные данные</b> — любая информация, относящаяся к прямо или косвенно определённому
          или определяемому физическому лицу (субъекту персональных данных).
          <b> Обработка персональных данных</b> — любое действие (операция) или совокупность действий
          с персональными данными, включая сбор, запись, систематизацию, накопление, хранение,
          уточнение, извлечение, использование, передачу, блокирование, удаление и уничтожение.
        </p>

        <h2 className="text-base font-semibold mt-4">2. Состав обрабатываемых данных</h2>
        <p>Оператор обрабатывает следующие категории персональных данных Пользователя:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>имя (при добровольном указании);</li>
          <li>номер мобильного телефона;</li>
          <li>адрес электронной почты;</li>
          <li>адрес доставки (для заказов «на вынос» / с доставкой);</li>
          <li>сведения о заказах (состав, сумма, время, комментарии);</li>
          <li>технические данные (идентификатор сессии, IP-адрес, тип устройства).</li>
        </ul>

        <h2 className="text-base font-semibold mt-4">3. Цели обработки</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li>идентификация Пользователя и предоставление доступа в Сервис;</li>
          <li>приём, оформление и исполнение заказов;</li>
          <li>направление сервисных уведомлений (статус заказа, код подтверждения);</li>
          <li>выполнение требований налогового и бухгалтерского законодательства РФ;</li>
          <li>обеспечение безопасности и предотвращение мошенничества.</li>
        </ul>

        <h2 className="text-base font-semibold mt-4">4. Правовые основания</h2>
        <p>
          Обработка осуществляется на основании согласия субъекта персональных данных (ст. 6 ч. 1 п. 1
          152-ФЗ), в целях исполнения договора (п. 5) и соблюдения требований законодательства РФ (п. 2).
        </p>

        <h2 className="text-base font-semibold mt-4">5. Передача третьим лицам</h2>
        <p>
          Персональные данные не передаются третьим лицам, за исключением: выбранной Пользователем службы
          доставки, платёжного провайдера (для оплаты), оператора связи (для отправки SMS с кодом) и
          уполномоченных государственных органов в случаях, предусмотренных законом.
        </p>

        <h2 className="text-base font-semibold mt-4">6. Хранение и защита</h2>
        <p>
          Персональные данные хранятся на серверах, размещённых на территории Российской Федерации,
          в соответствии с ч. 5 ст. 18 152-ФЗ. Оператор применяет организационные и технические меры
          защиты: шифрование каналов связи (TLS), разграничение доступа, регулярные резервные копии,
          контроль действий персонала.
        </p>

        <h2 className="text-base font-semibold mt-4">7. Срок обработки</h2>
        <p>
          Персональные данные обрабатываются до момента отзыва согласия Пользователем или достижения
          целей обработки, но не дольше сроков, установленных законодательством РФ (в т. ч. 5 лет для
          первичных учётных документов согласно ст. 29 ФЗ «О бухгалтерском учёте»).
        </p>

        <h2 className="text-base font-semibold mt-4">8. Права субъекта</h2>
        <p>
          Пользователь вправе получать сведения о факте, целях и способах обработки своих данных,
          требовать их уточнения, блокирования или удаления, отзывать согласие на обработку.
          Для реализации указанных прав достаточно направить запрос на адрес электронной почты Оператора,
          указанный в заведении.
        </p>

        <h2 className="text-base font-semibold mt-4">9. Отзыв согласия</h2>
        <p>
          Согласие на обработку персональных данных может быть отозвано Пользователем в любой момент
          путём направления письменного заявления Оператору. После отзыва данные подлежат уничтожению,
          за исключением случаев, когда их хранение необходимо для выполнения Оператором требований
          законодательства РФ.
        </p>

        <h2 className="text-base font-semibold mt-4">10. Изменения Политики</h2>
        <p>
          Оператор вправе вносить изменения в настоящую Политику. Актуальная редакция всегда доступна
          по постоянной ссылке в Сервисе.
        </p>
      </div>
    </div>
  );
}
